import { PROFILE_DETAILS } from './index';
import { Action } from '../action';

export class ProfileDetailsDestroyAction implements Action {
	readonly type = PROFILE_DETAILS.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ProfileDetailsInitAction implements Action {
	readonly type = PROFILE_DETAILS.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}
